export default function getIsOnlySingleIcon({
  children,
  iconBefore,
  iconAfter
}) {
  if (children) {
    return false;
  }
  if (iconBefore && !iconAfter) {
    return true;
  }
  if (!iconBefore && iconAfter) {
    return true;
  }
  return false;
}